import FieldsPayStubEarningsStatementNew from './FieldsPayStubEarningsStatementNew'

export default FieldsPayStubEarningsStatementNew
